import React, { useState } from "react";
import { BACKEND_URL } from "../../constants";
import axios from "axios";

const PREFIX = "7hGk92Lm";

const AdminBillingPage = () => {
  const [password, setPassword] = useState("");
  const [token, setToken] = useState(null);
  const [data, setData] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    try {
      setError("");
      setLoading(true);

      const res = await axios.post(
        `${BACKEND_URL}/internal/${PREFIX}/login`,
        { password }
      );

      const token = res.data.token;
      setToken(token);
      await fetchBilling(token);

    } catch (err) {
      setError("Fel lösenord");
    } finally {
      setLoading(false);
    }
  };

  const fetchBilling = async (token) => {
    try {
      const res = await axios.get(
        `${BACKEND_URL}/internal/${PREFIX}/billing-overview`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setData(res.data);

    } catch (err) {
      console.error("Billing fetch error:", err);
    }
  };

  const getStatus = (c) => {
    if (!c.nextBillingDate) return "unknown";

    const now = new Date();
    const date = new Date(c.nextBillingDate);

    if (date <= now) return "due";
    return "upcoming";
  };

  const getStatusStyle = (status) => {
    switch (status) {
      case "due":
        return { color: "#ff3b30", fontWeight: "600" };
      case "upcoming":
        return { color: "#34c759", fontWeight: "600" };
      default:
        return { color: "#999" };
    }
  };

  const renderDaysInfo = (c) => {
    if (c.daysUntilBilling === null || c.daysUntilBilling === undefined) return null;

    if (c.daysUntilBilling < 0) {
      return (
        <span style={{ color: "#ff3b30" }}>
          {Math.abs(c.daysUntilBilling)} dagar sen
        </span>
      );
    }

    if (c.daysUntilBilling === 0) {
      return <span style={{ color: "#ff9500" }}>Idag</span>;
    }

    return (
      <span style={{ color: "#34c759" }}>
        Om {c.daysUntilBilling} dagar
      </span>
    );
  };

  // 🔐 LOGIN
  if (!token) {
    return (
      <div style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#f7f7f7",
      }}>
        <div style={{
          background: "#fff",
          padding: 30,
          borderRadius: 12,
          width: 320,
          boxShadow: "0 10px 30px rgba(0,0,0,0.1)"
        }}>
          <h2 style={{ marginBottom: 20 }}>Admin Access</h2>

          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Lösenord"
            style={{
              width: "100%",
              padding: 10,
              borderRadius: 8,
              border: "1px solid #ddd",
              marginBottom: 12
            }}
          />

          <button
            onClick={handleLogin}
            style={{
              width: "100%",
              padding: 10,
              borderRadius: 8,
              border: "none",
              background: "#007aff",
              color: "#fff",
              fontWeight: "600",
              cursor: "pointer"
            }}
          >
            {loading ? "Loading..." : "Enter"}
          </button>

          {error && (
            <p style={{ color: "red", marginTop: 10 }}>{error}</p>
          )}
        </div>
      </div>
    );
  }

  // 📊 DATA VIEW
  return (
    <div style={{
      padding: 40,
      background: "#f7f7f7",
      minHeight: "100vh"
    }}>
      <h2 style={{ marginBottom: 20 }}>Billing Overview</h2>

      {data.length === 0 && <p>Inga företag hittades</p>}

      {data.map((c, i) => {
        const status = getStatus(c);

        return (
          <div
            key={i}
            style={{
              background: "#fff",
              padding: 20,
              borderRadius: 12,
              marginBottom: 12,
              boxShadow: "0 5px 15px rgba(0,0,0,0.05)",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center"
            }}
          >
            {/* LEFT */}
            <div>
              <div style={{ fontWeight: "600", fontSize: 16 }}>
                {c.name}
              </div>

              {c.orgNumber && (
                <div style={{ fontSize: 12, color: "#999" }}>
                  Org.nr: {c.orgNumber}
                </div>
              )}

              {c.email && (
                <div style={{ fontSize: 12, color: "#999" }}>
                  {c.email}
                </div>
              )}

              <div style={{ marginTop: 6, fontSize: 13, color: "#666" }}>
                {c.actualEmployees} / {c.employeesAllowed} användare
              </div>

              <div style={{ marginTop: 6, fontSize: 13 }}>
                {renderDaysInfo(c)}
              </div>

              <div style={{ marginTop: 6, fontSize: 12, color: "#aaa" }}>
                {c.nextBillingDate
                  ? new Date(c.nextBillingDate).toLocaleDateString()
                  : "Inget datum"}
              </div>
            </div>

            {/* RIGHT */}
            <div style={{ textAlign: "right" }}>
              <div style={{ fontWeight: "600", fontSize: 16 }}>
                {c.amount} kr
              </div>

              <div style={getStatusStyle(status)}>
                {status === "due" && "Ska faktureras"}
                {status === "upcoming" && "Kommande"}
                {status === "unknown" && "Okänd"}
              </div>

              <div style={{
                marginTop: 6,
                fontSize: 12,
                color: c.subscriptionStatus === "past_due" ? "#ff3b30" : "#999"
              }}>
                {c.subscriptionStatus}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default AdminBillingPage;